module.exports = __webpack_public_path__ + "static/media/shells1_bw.dada045c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shells1_bw.jpg
// module id = 30
// module chunks = 0